import { computed, ref } from 'vue'
import { createData } from './partials/data'
import { createMap } from './partials/map'
import { toQueryString } from '../../helpers/queryString'

/**
 * Create sections for the fac search state
 */
const data = createData()
const map  = createMap()

const state = {
    /**
     * Objects for the different sections of the state
     */
    data : data,
    map  : map,

    memberFieldsForSection: (section, member) => {
        if(!member?.member_fields){
            return []
        }

        const fieldIds = Object.keys(data.fac_type.fieldsForDisplayLocations.value[section] ?? [])

        return member.member_fields.filter(memberField => fieldIds.includes(String(memberField.field_id)))
    },

    memberProfileUrl: (membershipId, url = undefined, additionalParams = {}) => {
        const origin = new URL(url ?? window.location)
        
        origin.pathname += origin.pathname.endsWith('/')
            ? membershipId
            : `/${membershipId}`

        if(!origin.searchParams.has('action')){
            origin.searchParams.set('action', 'search')
        }

        if(Object.values(additionalParams).length > 0){
            toQueryString(additionalParams, origin.searchParams, true)
        }

        return origin.toString()
    },


    /**
     * Finds the search information for the given fac type
     * 
     * @param {String} facType 
     * @returns {Object|undefined}
     */
    facSearch: (facType) => (window.phpVals?.acc?.fac_types ?? []).find(
        (searchableFacType) => searchableFacType.fac_type === facType
    ),

    rootSearchUrl: computed(() => {
        const origin = new URL(window.location)

        const pathParts = origin.pathname.split('/');
        
        if(pathParts.pop() === ''){ //If the last item was empty we should remove another
            pathParts.pop()
        }

        origin.pathname = pathParts.join('/')

        return origin.toString()
    }),

    searching : ref(false),
    view      : ref('list'),

    reset: () => {
        data.fac_type.api.reset()
        data.fac_type_membership.api.reset()
        data.fac_type_memberships.api.reset()
    }
}

export default state

/**
 * So we can access these parts of the state independently inside the different steps
 */
export {
    data,
    map
}
